function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3f51b5;}.cls-2{fill:#fff;}.cls-3{font-size:275.97px;font-family:Roboto-Medium, Roboto;}.cls-4{letter-spacing:-.03em;}.cls-5{letter-spacing:-.01em;}.cls-6{letter-spacing:-.01em;}.cls-7{letter-spacing:0em;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logo-extended");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 16,
  y: 17,
  width: 280,
  height: 280,
  rx: 52.75,
  ry: 52.75
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M41,275,177,138l-69.68,26c-4,1.72-7.78.39-11.53-4L73,138c-10-10-6-22,7-26L216,75c18-5,28,2,24,21L203,234c-3,13-19,16-27,8l-18-19c-9.73-10.74-26.5-6-47,7Z"
});

var _ref6 = /*#__PURE__*/React.createElement("text", {
  className: "cls-3",
  transform: "translate(310.72 267.14)"
}, "u", /*#__PURE__*/React.createElement("tspan", {
  className: "cls-4",
  x: 153.35,
  y: 0
}, "T"), /*#__PURE__*/React.createElement("tspan", {
  className: "cls-5",
  x: 312.08,
  y: 0
}, "r"), /*#__PURE__*/React.createElement("tspan", {
  className: "cls-6",
  x: 405.06,
  y: 0
}, "a"), /*#__PURE__*/React.createElement("tspan", {
  className: "cls-7",
  x: 552.34,
  y: 0
}, "vel"));

var SvgLogoExtended = function SvgLogoExtended(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 1238.06 330.03",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoExtended, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-extended.c5490997.svg";
export { ForwardRef as ReactComponent };